<app-card>
  <div class="reset-password-container">
    <div class="reset-password-form-wrapper" *ngIf="!isSuccess">
      <h1>{{ 'auth.resetPassword.title' | transloco }}</h1>
      <p class="subtitle">{{ 'auth.resetPassword.subtitle' | transloco }}</p>

      <app-alert-card *ngIf="errorMessage" [message]="errorMessage" [dismissible]="false"></app-alert-card>

      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" *ngIf="!errorMessage">
        <div class="form-row">
          <div class="password-input-container">
            <app-input
              [label]="'auth.resetPassword.password' | transloco"
              formControlName="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              [placeholder]="'auth.resetPassword.passwordPlaceholder' | transloco"
              [hasIcon]="true"
              [iconPosition]="'right'"></app-input>
            <app-button tabindex="-1" [icon]="true" type="button" variant="outline" color="secondary" (click)="togglePasswordVisibility()">
              @if(showPassword){
              <i class="fas fa-eye-slash"></i>
              } @else {
              <i class="fas fa-eye"></i>
              }
            </app-button>
          </div>

          <!-- Password strength indicator -->
          <app-password-strength [password]="resetPasswordForm.get('password')?.value"></app-password-strength>
        </div>

        <div class="form-row">
          <div class="password-input-container">
            <app-input
              [label]="'auth.resetPassword.confirmPassword' | transloco"
              formControlName="confirmPassword"
              name="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'"
              [placeholder]="'auth.resetPassword.confirmPasswordPlaceholder' | transloco"
              [hasIcon]="true"
              [iconPosition]="'right'"></app-input>
            <app-button tabindex="-1" [icon]="true" type="button" variant="outline" color="secondary" (click)="toggleConfirmPasswordVisibility()">
              @if(showConfirmPassword){
              <i class="fas fa-eye-slash"></i>
              } @else {
              <i class="fas fa-eye"></i>
              }
            </app-button>
          </div>
        </div>

        <div class="form-actions">
          <app-button [block]="true" [type]="'submit'" [disabled]="resetPasswordForm.invalid || isSubmitting">
            {{ isSubmitting ? ('auth.common.loading' | transloco) : ('auth.resetPassword.submitButton' | transloco) }}
          </app-button>
        </div>

        <div class="login-link">
          <a [routerLink]="[languageRoutingService.getLocalizedRoute('/login')]">{{ 'auth.resetPassword.backToLogin' | transloco }}</a>
        </div>
      </form>
    </div>

    <!-- Success Message after password reset -->
    <div class="success-message-container" *ngIf="isSuccess">
      <div class="success-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <h2>{{ 'auth.resetPassword.successTitle' | transloco }}</h2>
      <p>{{ 'auth.resetPassword.successMessage' | transloco }}</p>
      <div class="success-actions">
        <app-button [block]="true" [routerLink]="[languageRoutingService.getLocalizedRoute('/login')]">
          {{ 'auth.resetPassword.loginButton' | transloco }}
        </app-button>
      </div>
    </div>
  </div>
</app-card>
